import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    image: {
      width: '200px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
